import ReactDOM from 'react-dom';
import React from 'react';
import IntlWrapper from 'components/layout/intlWrapper';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import events from 'lib/events';
import encyclopediaApi from 'api/encyclopedia';
import ArticleContents from 'components/articles/articleContents';
import Loader from 'components/loader';
// Libs
import router from '../../lib/router.js';


// helper
const replaceAll = (target, search, replacement) => target.split(search).join(replacement);

// Page object
class _TermsOfService extends React.Component {
  static displayName = 'TermsOfService';
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {loading: true, article: null};

  componentDidMount() {
    this.fetchData();
    this.unsub = events.subscribe('set.language', this.fetchData);
  }

  componentWillUnmount() {
    if (this.unsub && this.unsub.remove) {
      this.unsub.remove();
    }
  }

  fetchData = (locale) => {
    locale = locale || this.props.intl.locale;
    this.setState({loading: true, article: null});
    encyclopediaApi.getTermsOfService(locale).then(article => {
      this.setState({article: {title: article.title, body: article.detailedSection || article.description, id: article.id, id: article.id}, loading: false});
    }).catch(err => {
      console.error(err);
      this.setState({loading: false});
    });
  }

  render() {
    if (!this.state.loading && !this.state.article) {
      return <div className='container'>
        <h1><FormattedMessage id="general.terms.use"/></h1>
        <p><FormattedMessage id='article.load.failed' /></p>
      </div>;
    }
    return <div className='container'>
      <Loader loaded={!this.state.loading && !!this.state.article}>
        <ArticleContents article={this.state.article} formatMessage={this.props.intl.formatMessage} disableFooter={true} urlContext={'terms-of-service'}/>
      </Loader>
    </div>;
  }
}

const TermsOfService = injectIntl(_TermsOfService);

export default TermsOfService;


// Register in router
let isMounted = false;
let render = container => {
  if(!isMounted) {
    console.info('[UI.page.terms-of-service] rendering page');
    ReactDOM.render(<IntlWrapper><TermsOfService /></IntlWrapper>, container);
  }
};

console.info('[UI.page.terms-of-service] register route');
router.rr.add([{path: 'terms-of-service/:sub', handler: render}]);
router.rr.add([{path: 'terms-of-service', handler: render}]);
